<template>
  <article class="tile is-child box h-100" style="overflow: auto">
    <div class="h-100 w-100 is-flex is-flex-direction-column">
      <h1 class="title">PROFILE</h1>
      <div class="field">
        <div class="control-label" />
        <div class="control is-grouped">
          <div class="avatar-me" style="position: relative">
            <div v-if="body.profile.avatar" class="avatar">
              <!-- <img-profile
                :image="body.profile.avatar"
                :height="'100px'"
                :width="'100px'"
                :hoverable="true"
                onclick="document.getElementById('avatar').click()"
              >
                <div>Click to change</div>
              </img-profile> -->
              <img
                :src="body.profile.avatar"
                class="fit-cover is-cursor-pointer"
                style="border-radius: 50%"
                onclick="document.getElementById('avatar').click()"
              />
              <div
                class="icon-camera is-cursor-pointer"
                onclick="document.getElementById('avatar').click()"
              >
                <i class="fa fa-camera" style="display: block" />
              </div>
            </div>
            <span
              v-else
              onclick="document.getElementById('avatar').click()"
              class="is-cursor-pointer"
              ><i class="fa fa-user-circle-o fa-5x"
            /></span>
            <input
              id="avatar"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onChangeAvatar($event.target.files[0])"
            />
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control-label">
          <label class="label">Username</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.username"
              v-validate="'required|max:255|email'"
              :class="{ 'is-danger': errors.has('username') }"
              name="username"
              class="input"
              type="text"
              placeholder="Enter username"
              disabled
            />
            <span v-show="errors.has('username')" class="help is-danger">{{
              errors.first("username")
            }}</span>
          </p>
        </div>
      </div>

      <div class="field">
        <div class="control-label field-required">
          <label class="label field-required">First Name</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.profile.firstname"
              v-validate="'required|max:255'"
              :class="{ 'is-danger': errors.has('firstname') }"
              name="firstname"
              class="input"
              type="text"
              placeholder="Enter first name"
            />
            <span v-show="errors.has('firstname')" class="help is-danger">{{
              errors.first("firstname")
            }}</span>
          </p>
        </div>
      </div>

      <div class="field">
        <div class="control-label">
          <label class="label field-required">Last Name</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.profile.lastname"
              v-validate="'required|max:255'"
              :class="{ 'is-danger': errors.has('lastname') }"
              name="lastname"
              class="input"
              type="text"
              placeholder="Enter last name"
            />
            <span v-show="errors.has('lastname')" class="help is-danger">{{
              errors.first("lastname")
            }}</span>
          </p>
        </div>
      </div>

      <div class="field">
        <div class="control-label">
          <label class="label field-required">Phone</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.profile.phone"
              v-validate="'required|numeric'"
              :class="{ 'is-danger': errors.has('phone') }"
              name="phone"
              class="input"
              type="text"
              placeholder="Enter phone"
            />
            <span v-show="errors.has('phone')" class="help is-danger">{{
              errors.first("phone")
            }}</span>
          </p>
        </div>
      </div>

      <!-- <div class="field">
      <div class="control-label">
        <label class="label">Gender</label>
      </div>
      <div class="control is-grouped">
        <div class="select">
          <select v-model="body.profile.gender">
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="control-label">
        <label class="label field-required">Postal Code</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input
            v-validate="'required|numeric'"
            :class="{'is-danger': errors.has('postal_code') }"
            name="postal_code"
            v-model="body.profile.postal_code"
            class="input"
            type="text"
            placeholder="Enter postal code"
          >
          <span
            v-show="errors.has('postal_code')"
            class="help is-danger"
          >{{ errors.first('postal_code') }}</span>
        </p>
      </div>
    </div>

    <div class="field">
      <div class="control-label">
        <label class="label field-required">City</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input
            v-validate="'required|max:255'"
            :class="{'is-danger': errors.has('city') }"
            name="city"
            v-model="body.profile.city"
            class="input"
            type="text"
            placeholder="Enter city"
          >
          <span
            v-show="errors.has('city')"
            class="help is-danger"
          >{{ errors.first('city') }}</span>
        </p>
      </div>
    </div> -->

      <div class="field">
        <div class="control-label">
          <label class="label field-required">Address</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.profile.address"
              v-validate="'required|max:255'"
              :class="{ 'is-danger': errors.has('address') }"
              name="address"
              class="input"
              type="text"
              placeholder="Enter address"
            />
            <span v-show="errors.has('address')" class="help is-danger">{{
              errors.first("address")
            }}</span>
          </p>
        </div>
      </div>
      <div v-if="showPassword" class="field">
        <div class="control-label">
          <label class="label field-required">New Password</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="password"
              v-validate="'required|min:6|max:255'"
              :class="{ 'is-danger': errors.has('password') }"
              name="password"
              class="input"
              type="text"
              placeholder="Enter password"
            />
            <span v-show="errors.has('password')" class="help is-danger">{{
              errors.first("password")
            }}</span>
          </p>
        </div>
      </div>
      <div class="field">
        <div class="control-label is-flex">
          <label class="label">Password </label>
          <a class="mt-5" @click="openModalCard"> &nbsp;(Reset)</a>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <span class="">******</span>
            <!-- <a
              @click="openModalCard"
              class="is-pulled-right"
            > Reset password</a> -->
          </p>
        </div>
      </div>
      <div
        class="is-flex is-justify-content-space-between is-align-items-flex-end mb-10"
        style="flex: 1"
      >
        <!-- v-if="isSave" -->
        <save-button :disabled="!isSave" :loading="isSaving" @click="save" />
        <!-- <button
            class="button is-primary"
            @click="openModalCard"
          >
            Reset password
          </button> -->
        <!-- <a
            @click="cancel"
            class="button is-link"
          >Cancel</a> -->
      </div>
    </div>
  </article>
</template>

<script>
  import { media } from "api";
  import mixin from "components/mixin";
  import CardModal from "./components/ResetPassword";
  import Vue from "vue";
  import fx from "utils/fx";

  const CardModalComponent = Vue.extend(CardModal);
  const openCardModal = (
    propsData = {
      visible: true,
      loading: true,
    }
  ) => {
    // console.log(propsData);
    return new CardModalComponent({
      el: document.createElement("div"),
      propsData,
    });
  };
  export default {
    components: {
      "img-profile": () => import("./components/PanThumb/index"),
    },
    mixins: [mixin],
    props: {
      data: {
        type: Object,
        default() {
          return {};
        },
      },
      isSaving: Boolean,
      saveSuccess: Boolean,
    },
    data() {
      return {
        body: {
          username: this.data.username ? this.data.username : "",
          profile: {
            firstname:
              this.data.profile && this.data.profile.firstname
                ? this.data.profile.firstname
                : "",
            lastname:
              this.data.profile && this.data.profile.lastname
                ? this.data.profile.lastname
                : "",
            address:
              this.data.profile && this.data.profile.address
                ? this.data.profile.address
                : "",
            city:
              this.data.profile && this.data.profile.city
                ? this.data.profile.city
                : "",
            postal_code:
              this.data.profile && this.data.profile.postal_code
                ? this.data.profile.postal_code
                : "",
            phone:
              this.data.profile && this.data.profile.phone
                ? this.data.profile.phone
                : "",
            gender:
              this.data.profile && this.data.profile.gender
                ? this.data.profile.gender
                : "",
            avatar:
              this.data.profile && this.data.profile.avatar
                ? this.data.profile.avatar
                : "",
          },
        },
        isSave: false,
        showPassword: false,
        password: null,
      };
    },
    watch: {
      data: {
        handler(newval) {},
      },
      body: {
        handler(body) {
          this.isSave = true;
          this.$emit("update:saveSuccess", false);
        },
        deep: true,
      },
      saveSuccess(suc) {
        if (suc) {
          this.isSave = false;
        }
      },
    },
    created() {
      // console.log('this.data :>> ', this.data);
    },
    methods: {
      openModalCard() {
        //open popup show blacklist
        const cardModal = (this.cardModal = openCardModal({
          title: "Reset password",
        }));
        cardModal.$children[0].active();
      },
      onChangeAvatar(file) {
        media
          .uploadMulti([file])
          .then((res) => {
            if (res.data.success) {
              this.body.profile.avatar = res.data.data[0].full_url;
            }
          })
          .catch((err) => {
            let errors = err.response.data.error.message;
            if (err.response.data.error.errors) {
              let arr = [];
              for (let key in err.response.data.error.errors) {
                arr.push(err.response.data.error.errors[key]);
              }
              errors = arr.join();
            }
            this.openNotificationWithType("danger", {
              title: "Failed!",
              message: errors,
            });
            // this.formatShowError(err)
          });
      },
      cancel() {
        this.$emit("cancel");
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit("save", this.body.profile);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    /* overflow: hidden; */
    border: 2px solid #ccc;
    position: relative;
  }
  .avatar:hover {
    /* cursor: pointer; */
    opacity: 0.7;
  }
  .avatar-me {
    display: flex;
    justify-content: center;
    /* margin: 30px 0; */
  }
  .icon-camera {
    position: absolute;
    /* top: 0px; */
    background-color: white;
    border-radius: 50%;
    right: 5px;
    bottom: 0px;
    padding: 4px;
  }
  .icon-camera:hover {
    /* color: #0095db; */
  }
</style>
